import { RECOM_PROXY_BASE_PATH } from '@/data/recom/constants';
import { recomPaths } from '@/data/recom/endpoints';
import { recomRequest } from '@/data/recom/http';
import type {
	RecomIdentity,
	RecommendationParams,
	RecommendationResponse,
	RecommendationRuleValues,
	RecommendationType,
} from '@/data/recom/types';

export type RecomCallOptions = {
	signal?: AbortSignal;
	baseUrl?: string;
	timeoutMs?: number;
	headers?: Record<string, string>;
};

export const resolveRecomIdentity = ({ userId, sessionId }: RecomIdentity): RecomIdentity =>
	userId ? { userId } : sessionId ? { sessionId } : {};

export type GetRecommendationOptions = RecomCallOptions & {
	type: RecommendationType[];
	params?: Partial<Omit<RecommendationParams, 'storeId'>>;
	filters?: RecommendationRuleValues;
	priority?: RecommendationRuleValues;
};

export const getRecommendation = ({
	type,
	params,
	filters,
	priority,
	signal,
	baseUrl = RECOM_PROXY_BASE_PATH,
	timeoutMs,
	headers,
}: GetRecommendationOptions): Promise<RecommendationResponse> =>
	recomRequest<RecommendationResponse['data'], RecommendationResponse['meta']>({
		baseUrl,
		path: recomPaths.recommendation(),
		method: 'POST',
		body: {
			type,
			rules: {
				params: { ...params, queries: params?.queries ?? [] },
				filters,
				priority,
			},
		},
		signal,
		timeoutMs,
		headers,
	});
